<div class="d-flex gap-2 align-items-right justify-content-end YOID-footer">
    <span class="d-block opacity-50">{{ 'title.service_provided_by' | translate }}</span>
    <a [href]="url" target="_blank">
        <img src="assets/img/logo.svg" width="55" alt="YOiD icon">
    </a>
</div>